package songwritersnotebook.app.utils

import songwritersnotebook.app.getPlatform

/**
 * PRO OBSERVABILITY: A centralized logging and error reporting utility.
 * In development, it prints to the console.
 * In production, it filters debug logs and sends errors to a crash reporter.
 */
object AppLogger {
    private val isDebug = !getPlatform().name.contains("Release", ignoreCase = true)
    
    // Wire this up to Firebase Crashlytics in actual production setup
    private var reporter: ((Throwable, Map<String, String>) -> Unit)? = null

    fun setReporter(handler: (Throwable, Map<String, String>) -> Unit) {
        reporter = handler
    }

    fun d(tag: String, message: String) {
        if (isDebug) {
            println("DEBUG [$tag]: $message")
        }
    }

    fun i(tag: String, message: String) {
        println("INFO [$tag]: $message")
    }

    fun w(tag: String, message: String) {
        println("WARN [$tag]: $message")
    }

    fun e(tag: String, message: String, throwable: Throwable? = null, metadata: Map<String, String> = emptyMap()) {
        val fullMessage = "ERROR [$tag]: $message" + (throwable?.let { "\n${it.message}" } ?: "")
        println(fullMessage)
        throwable?.let { 
            it.printStackTrace()
            reporter?.invoke(it, metadata + ("tag" to tag) + ("message" to message))
        }
    }
}
